export enum OrderSource {
  Online = 0,
  InStore = 1,
}
